import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';
import { Controller } from 'react-hook-form';
import { InputDate } from '@tg/core/components';

const DateField = ({
  required,
  name,
  errors,
  defaultValue,
  id,
  translationKey,
  control,
  customLabel,
  ...props
}) => {
  const { t } = useTranslation('forms');

  const label = customLabel || t(`labels.${translationKey}`);
  const fieldId = `${id}.${name}`;

  // eslint-disable-next-line react/prop-types
  const { ref, ...inputProps } = props;

  return (
    <Form.Field required={required} error={!!errors}>
      <label htmlFor={fieldId}>{label}</label>
      <Controller
        as={<InputDate {...inputProps} />}
        control={control}
        name={fieldId}
        id={fieldId}
        placeholder={t(`placeholders.${translationKey}`)}
        defaultValue={defaultValue}
      />
      {errors && <p>{t(`validations.${errors.message.key}`)}</p>}
    </Form.Field>
  );
};

DateField.propTypes = {
  required: PropTypes.bool,
  name: PropTypes.string.isRequired,
  errors: PropTypes.object,
  id: PropTypes.string.isRequired,
  translationKey: PropTypes.string.isRequired,
  defaultValue: PropTypes.string,
  customLabel: PropTypes.node,
  control: PropTypes.any.isRequired,
};

DateField.defaultProps = {
  errors: null,
  defaultValue: '',
  customLabel: null,
  required: false,
};

export default DateField;
